import { useRef, useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Category as CategoryComponent } from "../../../atoms";
import { useCarrouselCategories } from "../../../../hooks/useCarrouselCategories";
import { HOME_ITEM } from "../../../../hooks/useCarrouselCategories";

import "swiper/css";
import "swiper/css/navigation";
import "../../../../styles/swipper-overrides.scss";
import styles from "./CarrouselCategories.module.scss";

interface Props {
  hidden?: boolean;
}

export const CarrouselCategories = ({ hidden }: Props) => {
  const { sortedItems, gap, setSwiperInstance, shouldRender } = useCarrouselCategories();
  const sentinelRef = useRef<HTMLDivElement>(null);
  const [isActuallySticky, setIsActuallySticky] = useState(false);

  useEffect(() => {
    if (!shouldRender) return;
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const handleScroll = () => {
      const threshold = sentinel.getBoundingClientRect().top + window.scrollY;
      setIsActuallySticky(window.scrollY > threshold);
    };

    handleScroll(); // estado inicial correcto si ya hay scroll al montar
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [shouldRender]);

  if (!shouldRender) return null;

  return (
    <>
      <div ref={sentinelRef} className={styles.sentinel} />
      <div data-sticky-categories-bar className={`${styles.containerCategories} ${isActuallySticky ? styles.isSticky : ""} ${hidden ? styles.hiddenCategories : ""}`}>

        <div className={styles.homeFixed}>
          <CategoryComponent category={HOME_ITEM} />
        </div>
        <Swiper
          className={styles.swiper}
          modules={[Navigation]}
          slidesPerView="auto"
          spaceBetween={gap}
          navigation
          observer
          observeParents
          onSwiper={setSwiperInstance}
        >
          {sortedItems.map(item => (
            <SwiperSlide key={item.id} style={{ width: "auto" }}>
              <div className={styles.itemWrap}>
                <CategoryComponent category={item.data} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};